// ========== Slide up & down ==========

export function nnSlideUp(target, duration = 500, callback = null) {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;

    window.setTimeout( () => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');

        if ( typeof callback === 'function' ) {
            callback();
        }
    }, duration);
}

export function nnSlideDown(target, duration = 500, callback = null) {
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;

    if (display === 'none') {
        display = 'block';

        target.style.display = display;
        let height = target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        target.offsetHeight;
        target.style.boxSizing = 'border-box';
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = duration + 'ms';
        target.style.height = height + 'px';
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');

        window.setTimeout( () => {
            target.style.removeProperty('height');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');

            if ( typeof callback === 'function' ) {
                callback();
            }
        }, duration);
    }
}

export function nnSlideToggle(target, duration = 500, callback = null) {
    if (window.getComputedStyle(target).display === 'none') {
        return nnSlideDown(target, duration, callback);
    } else {
        return nnSlideUp(target, duration, callback);
    }
}



// ========== throttle & debounce ==========

// const log = () => console.log('Action triggered');
// const tdThing = nnThrottleDebounce(log, 500, { leading: true, trailing: true });
// window.addEventListener('scroll', tdThing);

// const preTdDoHeaderColor = () => doHeaderColor($components);
// const tdDoHeaderColor = nnThrottleDebounce(preTdDoHeaderColor, 200);
// window.addEventListener('scroll', tdDoHeaderColor);

export function nnThrottleDebounce(fn, wait = 200, options = { leading: false, trailing: true }) {
    let lastExecuted = 0;
    let timer = null;
    let lastArgs = null;
    let lastContext = null;
  
    const { leading, trailing } = options;
  
    function invoke() {
        fn.apply(lastContext, lastArgs);
        lastExecuted = Date.now();
    }
  
    function invokeLater() {
        if (trailing && lastArgs) {
            invoke();
            lastArgs = null;
        }
    }
  
    return function(...args) {
        lastContext = this;
        lastArgs = args;
        const now = Date.now();
    
        if (lastExecuted === 0 && leading) {
            invoke();
            return;
        }
    
        const timeElapsed = now - lastExecuted;
    
        if (timeElapsed < wait) {
            if (timer) clearTimeout(timer);
            timer = setTimeout(invokeLater, wait - timeElapsed);
        } else {
            invoke();
        }
    };
}
  